import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LayoutMainComponent} from './layout-main/layout-main.component';
import {NzContentComponent, NzLayoutComponent, NzSiderComponent} from "ng-zorro-antd/layout";
import {NzPageHeaderComponent, NzPageHeaderExtraDirective} from 'ng-zorro-antd/page-header';
import {NzSpaceComponent} from 'ng-zorro-antd/space';
import {NzTagComponent} from 'ng-zorro-antd/tag';
import {NzButtonComponent} from 'ng-zorro-antd/button';
import {NzInputDirective, NzInputGroupComponent} from 'ng-zorro-antd/input';
import {EquipmentIconPipe, SharedModule} from '@app/shared';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LayoutDetailComponent} from './layout-detail/layout-detail.component';
import {NzBreadCrumbComponent, NzBreadCrumbItemComponent} from "ng-zorro-antd/breadcrumb";
import {NzDividerComponent} from 'ng-zorro-antd/divider';
import {RouterLink, RouterOutlet} from '@angular/router';
import {LayoutMaestroComponent} from './layout-maestro/layout-maestro.component';
import {NzAvatarComponent} from 'ng-zorro-antd/avatar';
import {
    NzCellAlignDirective,
    NzCellFixedDirective,
    NzTableComponent,
    NzThAddOnComponent,
    NzThMeasureDirective
} from 'ng-zorro-antd/table';
import {NzCheckboxComponent} from 'ng-zorro-antd/checkbox';
import {NzEmptyComponent} from 'ng-zorro-antd/empty';
import {NzPopconfirmDirective} from 'ng-zorro-antd/popconfirm';
import {NzDropDownDirective, NzDropdownMenuComponent} from "ng-zorro-antd/dropdown";
import {NzMenuDirective, NzMenuItemComponent} from "ng-zorro-antd/menu";
import {SearchModule} from '../features/search/search.module';
import {NzBadgeComponent} from "ng-zorro-antd/badge";
import {NzSegmentedComponent} from "ng-zorro-antd/segmented";
import {NzTooltipDirective} from 'ng-zorro-antd/tooltip';


@NgModule({
  declarations: [
    LayoutMainComponent,
    LayoutDetailComponent,
    LayoutMaestroComponent
  ],
    imports: [
        CommonModule,
        NzLayoutComponent,
        NzPageHeaderComponent,
        NzSpaceComponent,
        NzTagComponent,
        NzButtonComponent,
        NzInputGroupComponent,
        NzInputDirective,
        NzContentComponent,
        SharedModule,
        ReactiveFormsModule,
        FormsModule,
        NzBreadCrumbComponent,
        NzBreadCrumbItemComponent,
        NzSiderComponent,
        NzDividerComponent,
        RouterLink,
        RouterOutlet,
        EquipmentIconPipe,
        NzAvatarComponent,
        NzCellAlignDirective,
        NzCellFixedDirective,
        NzCheckboxComponent,
        NzTableComponent,
        NzThMeasureDirective,
        NzEmptyComponent,
        NzPopconfirmDirective,
        NzDropdownMenuComponent,
        NzMenuDirective,
        NzMenuItemComponent,
        NzDropDownDirective,
        NzPageHeaderExtraDirective,
        SearchModule,
        NzThAddOnComponent,
        NzBadgeComponent,
        NzSegmentedComponent,
        NzTooltipDirective
    ],
  exports: [
    LayoutMainComponent,
    LayoutDetailComponent,
    LayoutMaestroComponent
  ],
})
export class LayoutsModule {
}
